import { ImgHTMLAttributes } from 'react';
import babbarFavicon from './assets/babbar.png';

export const BabbarIcon = (props: ImgHTMLAttributes<HTMLImageElement>) => (
  <img src={babbarFavicon} width={12} height={12} {...props} alt="" aria-hidden="true" />
);
